var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrashCanRounded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 15,
    r: 12,
    fill: "#FBFBFB"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3077 13.0868C21.5486 13.1067 21.7283 13.3172 21.709 13.5582C21.7055 13.5978 21.3893 17.5126 21.2073 19.1547C21.0942 20.1737 20.421 20.7938 19.4048 20.8125C18.6273 20.8259 17.8771 20.8335 17.1438 20.8335C16.3534 20.8335 15.5828 20.8247 14.8204 20.809C13.8451 20.7897 13.1702 20.1574 13.0599 19.1587C12.8762 17.5021 12.5618 13.5972 12.5588 13.5582C12.539 13.3172 12.7187 13.1061 12.9596 13.0868C13.197 13.0804 13.4117 13.2472 13.4309 13.4876C13.4328 13.5129 13.5613 15.1075 13.7014 16.6852L13.7295 17.0001C13.8001 17.7843 13.8716 18.5379 13.9297 19.0625C13.9921 19.6301 14.2983 19.9229 14.8385 19.934C16.2968 19.9649 17.7849 19.9667 19.3891 19.9375C19.9631 19.9264 20.2734 19.6394 20.3376 19.0584C20.5184 17.4286 20.8334 13.5272 20.8369 13.4876C20.8562 13.2472 21.0691 13.0792 21.3077 13.0868ZM18.3681 9.16699C18.9036 9.16699 19.3744 9.52808 19.5126 10.0455L19.6608 10.7811C19.7087 11.0222 19.9203 11.1983 20.1653 11.2022L22.0797 11.2022C22.3212 11.2022 22.5172 11.3982 22.5172 11.6397C22.5172 11.8812 22.3212 12.0772 22.0797 12.0772L20.1824 12.0772C20.1795 12.0772 20.1765 12.0772 20.1736 12.0772L20.1593 12.0767L14.1076 12.0772C14.1029 12.0772 14.0982 12.0772 14.0935 12.0772L14.0845 12.0767L12.1875 12.0772C11.946 12.0772 11.75 11.8812 11.75 11.6397C11.75 11.3982 11.946 11.2022 12.1875 11.2022L14.1014 11.2017L14.1603 11.1979C14.3798 11.1695 14.5623 11.0027 14.6068 10.7811L14.7486 10.0717C14.8926 9.52808 15.3634 9.16699 15.8989 9.16699H18.3681ZM18.3681 10.042H15.8989C15.7589 10.042 15.6358 10.1359 15.6002 10.2707L15.4643 10.9532C15.447 11.0396 15.4219 11.1229 15.3897 11.2024H18.8775C18.8453 11.1229 18.8201 11.0396 18.8027 10.9532L18.661 10.2438C18.6312 10.1359 18.5081 10.042 18.3681 10.042Z",
    fill: "#D20E50"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.617188,
    y: 0.609375,
    width: 32.7656,
    height: 32.7656,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.398438,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.99219
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.99219
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashCanRounded);
export default __webpack_public_path__ + "static/media/trash-can-rounded.7523de9e.svg";
export { ForwardRef as ReactComponent };